import ReactGA from 'react-ga4';
import { GOOGLE_ANALYTICS } from 'settings';

const analyticsService = {
  initializeGTM: (userId?: number, belt?: string, betas?: string): void => {
    ReactGA.initialize([
      {
        trackingId: GOOGLE_ANALYTICS,
        gtagOptions: {
          user_id: userId,
          belt,
          betas,
        },
      },
    ]);
  },

  isGTMInitialized: ReactGA.isInitialized,

  sendEvent: (action: string, category: string): void => {
    ReactGA.event({
      action,
      category,
    });
  },
};

export default analyticsService;
